import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
    NbButton,
    NbButtonModule,
    NbCardModule,
    NbLayoutModule,
    NbMenuModule,
    NbSidebarModule,
} from "@nebular/theme";
import { ThemeModule } from "../@theme/theme.module";
import { AboutComponent } from "./about.component";
import { AboutRoutingModule } from "./about-routing.module";
import { AboutLayoutComponent } from "./about.layout";

@NgModule({
    declarations: [AboutComponent, AboutLayoutComponent],
    imports: [
        CommonModule,
        NbSidebarModule,
        NbMenuModule,
        NbLayoutModule,
        ThemeModule,
        NbCardModule,
        NbButtonModule,
        AboutRoutingModule,
    ],
})
export class AboutModule {}
